import { ETeamMemberRole } from '@app/swagger-types';

export const TeamRoleBadge: React.FC<{ teamRole?: ETeamMemberRole }> = ({ teamRole }) => {
  if (!teamRole || teamRole === ETeamMemberRole.NONE) {
    return <div className="inline-flex rounded-lg px-1 bg-gray-200 text-gray-700">no team</div>;
  }
  if (teamRole === ETeamMemberRole.OWNER) {
    return <div className="inline-flex rounded-lg px-1 bg-blue-200 text-blue-700">team owner</div>;
  }
  if (teamRole === ETeamMemberRole.MEMBER) {
    return <div className="inline-flex rounded-lg px-1 bg-purple-200 text-purple-700">team member</div>;
  }
  return <div className="inline-flex rounded-lg px-1 bg-pink-300 text-pink-700">{teamRole}</div>;
};
